// extracted by mini-css-extract-plugin
export default {"team-card":"TeamCard_team-card__j9pmI","pic":"TeamCard_pic__IXBU4","info":"TeamCard_info__h4Fmj","social":"TeamCard_social__lDYJt","icon":"TeamCard_icon__znndY"};